import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const Sidebar = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false); // State để kiểm soát trạng thái sidebar (mở/đóng)

  const toggleSidebar = () => setIsOpen(!isOpen); // Hàm để mở/đóng sidebar

  // Đóng sidebar khi đường dẫn thay đổi
  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  // Hàm để đóng sidebar khi người dùng click bên ngoài
  const closeSidebar = (e) => {
    if (e.target.id === "overlay") {
      setIsOpen(false); // Đóng sidebar nếu người dùng click vào overlay
    }
  };

  return (
    <div>
      {/* Nút mở sidebar (ở ngoài) */}
      {!isOpen && (
        <button
          onClick={toggleSidebar}
          className="fixed top-4 left-4 text-white bg-gray-700 hover:bg-gray-600 p-2 rounded-full z-50"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            strokeWidth="2"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M4 6h16M4 12h16M4 18h16"
            />
          </svg>
        </button>
      )}

      {/* Overlay (khi nhấn vào overlay, sidebar sẽ đóng) */}
      {isOpen && (
        <div
          id="overlay"
          className="fixed inset-0 bg-black opacity-50 z-40"
          onClick={closeSidebar}
        />
      )}

      {/* Sidebar */}
      <aside
        className={`fixed top-0 left-0 h-full bg-gray-800 text-white w-64 p-4 transition-transform duration-300 ease-in-out z-50 ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        {/* Nút đóng sidebar (ở trong sidebar) */}
        {isOpen && (
          <button
            onClick={toggleSidebar}
            className="absolute top-4 -right-5 text-white bg-red-700 hover:bg-gray-600 p-2 rounded-full z-50"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              strokeWidth="2"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        )}

        {/* Logo và menu các liên kết */}
        <div className="flex justify-items-start items-center mb-6">
          <img
            src="/images/iconweb.png"
            className="mr-2 h-12 sm:h-14"
            alt="Webdio Logo"
          />
          {isOpen && <span className="text-2xl font-semibold">𝓦𝓮𝓫𝓭𝓲𝓸</span>}
        </div>
        <div className="border-t-2 space-x-3 pb-3"></div>
        <nav className="flex flex-col space-y-4">
          <Link
            to="/extensions/converttext"
            className={`block py-2 px-4 rounded ${
              location.pathname === "/extensions/converttext"
                ? "bg-blue-700 text-white"
                : "text-gray-300 hover:bg-blue-500 hover:text-white"
            }`}
          >
            {isOpen ? "Convert Text" : ""}
          </Link>
          <Link
            to="/extensions/convertnumber"
            className={`block py-2 px-4 rounded ${
              location.pathname === "/extensions/convertnumber"
                ? "bg-blue-700 text-white"
                : "text-gray-300 hover:bg-blue-500 hover:text-white"
            }`}
          >
            {isOpen ? "Convert Number" : ""}
          </Link>
          <Link
            to="/extensions/donate"
            className={`block py-2 px-4 rounded ${
              location.pathname === "/extensions/donate"
                ? "bg-blue-700 text-white"
                : "text-gray-300 hover:bg-blue-500 hover:text-white"
            }`}
          >
            {isOpen ? "Donate" : ""}
          </Link>
          <Link
            to="/extensions/timeline"
            className={`block py-2 px-4 rounded ${
              location.pathname === "/extensions/timeline"
                ? "bg-blue-700 text-white"
                : "text-gray-300 hover:bg-blue-500 hover:text-white"
            }`}
          >
            {isOpen ? "Time Line" : ""}
          </Link>

          <div className="border-t-2 space-x-3 pb-3"></div>

          <div className="flex flex-col items-center justify-center">
            <p className="loading loading-dots loading-lg"></p>
            <h2 className="mt-4">Update V1</h2>
            <h3 className="mt-1">23:06, Th7 7/12/2024</h3>
          </div>
        </nav>
      </aside>
    </div>
  );
};

export default Sidebar;
